import React from 'react'
import './Footer.css'

export default function Footer() {
    return (
        <div className='footer-holder'>

            <footer class="footer" id="footer">
                <p>Made with ♥️ by Phoenix Corp</p>
              
                <p class="footer-copyright">&copy; All Rights Reserved.</p>
            </footer>

        </div>
    )
}